import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import { tannerGray, tannerWhite } from '../colors';

type MuiTooltip = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiTooltip'];
  defaultProps?: ComponentsProps['MuiTooltip'];
  variants?: ComponentsVariants['MuiTooltip'];
};

export const MuiTooltip: MuiTooltip = {
  defaultProps: {
    arrow: true,
  },
  styleOverrides: {
    arrow: {
      color: tannerGray['800'],
    },
    tooltip: {
      backgroundColor: tannerGray['800'],
      color: tannerWhite,
      fontSize: 12,
      padding: '8px 12px',
    },
  },
};
